<template lang='pug'>
#section2
	#section2-anchor
	.content-section
		.header
			h2 Um sápuboltann
			img.underline(src='@/assets/blue_wave.svg')
		.paragraph
			p Á mótinu spila fjórir saman í liði og engin takmörk eru á skiptimönnum. Mótið fer fram á dúk sem er 15x20 að stærð og notast er við handboltamörk. Liðin eru hvött til þess að mæta í búningum en veitt verða verðlaun fyrir flottasta búninginn ásamt öðrum skemmtilegum viðurkenningum á lokahófi Sápuboltans sem fer fram samdægurs. Þegar líða fer að kveldi tekur við skemmtun fram eftir nóttu.

	.image-section
		img.pattern(src='@/assets/circle_waves.svg')
		img.image(src='@/assets/images/1.png')
	img.pattern-mobile(src='@/assets/circle_waves.svg')
</template>

<script>
export default {
	name: 'Section2',
	methods: {
		changeNav: function (target) {
			this.$SmoothScroll(document.getElementById(target), 700, null, null, 'y');
			this.nav = false;
		}
	}
};
</script>

<style lang="less" scoped>
#section2 {
	#section2-anchor {
		width: 100vw;
		height: 5px;
		position: absolute;
		top: -150px;
	}
	position: relative;
	margin-top: 200px;
	padding-left: 117px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	@media screen and (max-width: 1439px) {
		grid-template-columns: 1fr;
		margin-top: 0px;
		padding-left: 0px;
	}
	.pattern-mobile {
		visibility: hidden;
		height: 0px;
	}
	.image-section {
		transform: translateY(-100px);
		@media screen and (max-width: 1439px) {
			transform: translateY(0px);
			margin-left: auto;
			margin-right: auto;
		}
		position: relative;
		.pattern {
			transform: translateY(-310px);
			position: absolute;
			right: 0px;
			z-index: 1;
			@media screen and (max-width: 1439px) {
				visibility: hidden;
			}
		}
		.image {
			transform: translateX(76px);
			@media screen and (max-width: 1439px) {
				transform: translateX(0px);
			}
			position: relative;
			z-index: 2;
		}
	}
	.content-section {
		@media screen and (max-width: 1439px) {
			position: relative;
			margin-left: auto;
			margin-right: auto;
		}
		@media screen and (max-width: 475px) {
			padding-left: 30px;
			padding-right: 30px;
		}
		.header {
			h2 {
				z-index: 2;
				position: relative;
				font-size: 40px;
				color: #f3736b;
				font-weight: bold;
				@media screen and (max-width: 870px) {
					font-size: 31px;
				}
			}
			.underline {
				z-index: 2;
				position: relative;
				transform: translateY(-20px);
			}
		}
		.paragraph {
			.button {
				margin-left: 78px;
				width: 158px;
				height: 48px;
				border-radius: 24px;
				border: solid 2px #118acd;
				line-height: 48px;
				text-align: center;
				font-size: 21px;
				font-weight: bold;
				transition: .5s;
				cursor: pointer;
				background: url('~@/assets/top.svg');
				background-size: 177px 101px;
				background-position-y: -100px;
				background-repeat: no-repeat;
				margin-bottom: 48px;
				&:hover {
					color: white;
					background-position-y: 0px;
				}
				@media screen and (max-width: 530px) {
					margin-left: auto;
					margin-right: auto;
				}
			}
			p {
				position: relative;
				transform: translateY(-10px);
				margin-top: 0px;
				max-width: 426px;
				line-height: 1.94;
				font-size: 18px;
				margin-left: 78px;
				z-index: 2;
				@media screen and (min-width: 1440px) {
					max-width: 626px;
				}
				@media screen and (max-width: 530px) {
					margin-left: 0px;
					font-size: 16px;
				}
			}
		}
	}
	@media screen and (max-width: 1439px) {
		.pattern-mobile {
			visibility: initial;
			position: absolute;
			right: 0px;
			height: auto;
			z-index: 1;
		}
	}
}
</style>
